import { fetchManufacturers } from 'api/manufacturer';

/** SKU modals: same `/manufacturer/list` source as purchase orders. */
export const fetchAllManufacturers = () => fetchManufacturers();
